import type { AxiosError } from 'axios';

interface ApiErrorBody {
  error?: string;
  message?: string;
}

// Logs the backend's detailed error to the console so it's visible in dev tools,
// while pages keep showing their own generic toast message to the user.
// (The raw response is also in the Network tab; this surfaces the `error`
// detail that validation failures return but the toast hides.)
export function logApiError(error: AxiosError<ApiErrorBody>): void {
  const { response, config, message } = error;
  const method = config?.method?.toUpperCase() ?? '?';
  const url = config?.url ?? '?';
  const status = response?.status ?? 'no response';
  const detail = response?.data?.error ?? response?.data?.message ?? message;

  console.error(`[API] ${method} ${url} → ${status}: ${detail}`, response?.data);
}
